import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SITE } from "@/config/site";
import { useLang } from "@/contexts/LanguageContext";

export default function Loader() {
  const [visible, setVisible] = useState(true);
  const { t } = useLang();

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 1400);
    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="page-loader"
          className="fixed inset-0 z-[100] bg-navy-800 flex flex-col items-center justify-center"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.6 } }}
        >
          <div className="absolute inset-0 grid-blueprint opacity-30" />
          <div className="relative">
            {/* Rotating gear */}
            <svg
              className="loader-gear-track w-28 h-28 animate-gear-med"
              viewBox="0 0 100 100"
              fill="none"
              aria-hidden="true"
            >
              <g stroke="#D4AF37" strokeWidth="1.5">
                <circle cx="50" cy="50" r="22" />
                <circle cx="50" cy="50" r="8" fill="#D4AF37" fillOpacity="0.15" />
                {Array.from({ length: 12 }).map((_, i) => {
                  const angle = (i * 30 * Math.PI) / 180;
                  const x1 = 50 + Math.cos(angle) * 28;
                  const y1 = 50 + Math.sin(angle) * 28;
                  const x2 = 50 + Math.cos(angle) * 36;
                  const y2 = 50 + Math.sin(angle) * 36;
                  return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} strokeLinecap="square" />;
                })}
              </g>
            </svg>
            <img
              src={SITE.logoUrl}
              alt="Elite Al Hijaz"
              className="absolute inset-0 m-auto w-12 h-12 rounded-full object-cover"
            />
          </div>
          <div className="mt-8 text-overline">{t.common.loading}</div>
          <div className="mt-3 text-metallic font-heading font-bold text-lg tracking-tight">
            ELITE AL HIJAZ Est.
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
